import Lock from "@mui/icons-material/Lock";
import type { ChipProps } from "@mui/material";
import { Chip } from "@mui/material";
import type { FC } from "react";

export const RestrictedChip: FC<ChipProps> = ({ ...props }) => {
  return (
    <Chip
      variant="outlined"
      size="small"
      color="warning"
      icon={<Lock />}
      label="RESTRICTED"
      {...props}
    />
  );
};
